import { render, staticRenderFns } from "./Nabytok.vue?vue&type=template&id=6d61442b&scoped=true"
import script from "./Nabytok.vue?vue&type=script&lang=js"
export * from "./Nabytok.vue?vue&type=script&lang=js"
import style0 from "./Nabytok.vue?vue&type=style&index=0&id=6d61442b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d61442b",
  null
  
)

export default component.exports